import { render, staticRenderFns } from "./CheckToken.vue?vue&type=template&id=8ed8a9ea&scoped=true&"
import script from "./CheckToken.vue?vue&type=script&lang=js&"
export * from "./CheckToken.vue?vue&type=script&lang=js&"
import style0 from "./CheckToken.vue?vue&type=style&index=0&id=8ed8a9ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed8a9ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ed8a9ea')) {
      api.createRecord('8ed8a9ea', component.options)
    } else {
      api.reload('8ed8a9ea', component.options)
    }
    module.hot.accept("./CheckToken.vue?vue&type=template&id=8ed8a9ea&scoped=true&", function () {
      api.rerender('8ed8a9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CheckToken.vue"
export default component.exports